import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import Callout from 'modules/core/components/Callout'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useGetSubmittedImporterProcess } from 'modules/employees/hooks/useGetSubmittedImporterProcess'

const ImporterStatus = {
  submitted: 'submitted',
  success: 'success',
  failure: 'failure',
}

const ImporterCallout = () => {
  const { access, company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [importerCalloutType, setImporterCalloutType] = useState<string>()
  const { importerProcess, importerActivity, loading } = useGetSubmittedImporterProcess({
    companyId: company.id,
    accessId: access.id,
  })
  const [hasSeenSubmittedCallout, setHasSeenSubmittedCallout] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.employeesImporterSubmittedCalloutSeen
  )

  const [hasSeenFinishededCallout, setHasSeenFinishededCallout] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.employeesImporterFinishedCalloutSeen
  )

  useEffect(() => {
    if (
      importerActivity?.state === ImporterStatus.submitted &&
      hasSeenSubmittedCallout !== importerProcess?.uuid
    ) {
      setImporterCalloutType(ImporterStatus.submitted)
    }
    if (
      importerActivity?.state === ImporterStatus.success &&
      hasSeenFinishededCallout !== importerProcess?.uuid
    ) {
      setImporterCalloutType(ImporterStatus.success)
    }
    if (
      importerActivity?.state === ImporterStatus.failure &&
      hasSeenFinishededCallout !== importerProcess?.uuid
    ) {
      setImporterCalloutType(ImporterStatus.failure)
    }
  }, [
    hasSeenFinishededCallout,
    hasSeenSubmittedCallout,
    importerActivity?.state,
    importerProcess?.uuid,
  ])

  if (loading || !importerProcess) return null

  const handleOnRemoveSubmitted = () => {
    setImporterCalloutType(undefined)
    setHasSeenSubmittedCallout(importerProcess?.uuid)
  }

  const handleOnRemoveFinished = () => {
    setImporterCalloutType(undefined)
    setHasSeenFinishededCallout(importerProcess?.uuid)
  }

  const handleOnPageRefresh = () => {
    window.location.reload()
    handleOnRemoveFinished()
  }

  const handleImportAgain = () => {
    navigate(navigation.employees.importProcess.fullPath())
    handleOnRemoveFinished()
  }

  return (
    <>
      {importerCalloutType === ImporterStatus.submitted && !!importerProcess?.itemsToBeCreated && (
        <Callout
          type="info"
          description={i18n.tp('employees.importer_callout.submitted_description', {
            count: importerProcess.itemsToBeCreated,
          })}
          compact
          onRemove={() => handleOnRemoveSubmitted()}
        />
      )}
      {importerCalloutType === ImporterStatus.success && !!importerProcess?.itemsCreated && (
        <Callout
          type="positive"
          description={i18n.tp('employees.importer_callout.success_description', {
            count: importerProcess.itemsCreated,
          })}
          compact
          onRemove={() => handleOnRemoveFinished()}
          link={
            <Button onClick={() => handleOnPageRefresh()} type="secondary">
              {i18n.t('employees.importer_callout.buttons.refresh')}
            </Button>
          }
        />
      )}
      {importerCalloutType === ImporterStatus.failure && (
        <Callout
          type="critical"
          description={i18n.t('employees.importer_callout.failure_description')}
          compact
          onRemove={() => handleOnRemoveFinished()}
          link={
            <Button onClick={() => handleImportAgain()} type="secondary">
              {i18n.t('employees.importer_callout.buttons.import_employees')}
            </Button>
          }
        />
      )}
    </>
  )
}

export default ImporterCallout
